export default __webpack_public_path__ + "static/media/price-high.d062bf91.svg";